import { LegalLayout, Section, SubHead, Bullets } from '../components/LegalLayout';
import { BRAND } from '../lib/constants';

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title={<>Privacy <span className="italic text-[#a465a8]">Policy</span>.</>}
      effective="01 February 2026"
      testId="privacy-policy-page"
      intro={
        <>Welcome to <strong>Find Your MUA</strong> ("Platform", "we", "our", "us"). We value your trust and are committed to protecting your privacy. This policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. By accessing or using Find Your MUA, you agree to the terms of this Privacy Policy.</>
      }
    >
      <Section n="01" title="About Find Your MUA">
        <p>Find Your MUA is a <strong>beauty discovery and booking platform</strong> that connects clients with carefully vetted and curated makeup artists, hairstylists, and beauty professionals. We act as an <strong>intermediary platform</strong> facilitating artist discovery and bookings. We do not directly provide beauty services.</p>
      </Section>

      <Section n="02" title="Information We Collect">
        <SubHead>A. Personal Information</SubHead>
        <Bullets items={['Full name', 'Phone number', 'Email address', 'City/location', 'Event details', 'Booking preferences', 'Payment details']} />
        <SubHead>B. Artist Information</SubHead>
        <p>For artist onboarding, we may collect:</p>
        <Bullets items={['Professional portfolio', 'Social media handles', 'Service pricing', 'Business details', 'City &amp; pincode', 'Google Maps location', 'Experience details', 'Service categories']} />
        <SubHead>C. Automatically Collected Data</SubHead>
        <Bullets items={['Device information', 'Browser type', 'IP address', 'Website activity', 'Cookies and analytics information']} />
      </Section>

      <Section n="03" title="How We Use Your Information">
        <Bullets items={[
          'Facilitate bookings',
          'Match users with suitable artists',
          'Process payments',
          'Improve platform experience',
          'Communicate updates and support',
          'Verify artist information',
          'Prevent fraud and misuse',
          'Send marketing communications (with consent)',
        ]} />
      </Section>

      <Section n="04" title="Payment Information">
        <p>Payments made through the Platform may be processed through secure third-party payment gateways. We do not store sensitive payment details such as card information.</p>
      </Section>

      <Section n="05" title="Sharing of Information">
        <SubHead>With Makeup Artists</SubHead>
        <p>To facilitate bookings and consultations.</p>
        <SubHead>With Service Providers</SubHead>
        <Bullets items={['Payment processing', 'Hosting', 'Website analytics', 'Customer support']} />
        <SubHead>Legal Requirements</SubHead>
        <p>If required by law, court order, or legal proceedings. We do <strong>not sell personal information</strong> to third parties.</p>
      </Section>

      <Section n="06" title="Artist Verification Disclaimer">
        <p>Find Your MUA works with <strong>carefully vetted and curated artists</strong>. However, while we take reasonable efforts to review artists, we do not guarantee quality, suitability, availability, or outcomes of services. Clients are encouraged to conduct personal consultations before confirming bookings.</p>
      </Section>

      <Section n="07" title="Cookies">
        <p>We may use cookies to:</p>
        <Bullets items={['Improve website performance', 'Remember user preferences', 'Analyze traffic', 'Improve user experience']} />
        <p>Users may disable cookies through browser settings.</p>
      </Section>

      <Section n="08" title="Data Security">
        <p>We implement commercially reasonable safeguards to protect user information. However, no online transmission or storage system can be guaranteed to be completely secure.</p>
      </Section>

      <Section n="09" title="Third-Party Links">
        <p>Our Platform may contain links to third-party websites, including artist social media profiles. We are not responsible for their privacy practices.</p>
      </Section>

      <Section n="10" title="User Rights">
        <p>You may request:</p>
        <Bullets items={['Access to your data', 'Correction of information', 'Deletion of personal data', 'Withdrawal of consent']} />
        <p>To request this, contact us at: <a href={`mailto:${BRAND.email}`} className="text-[#eb5381] underline">{BRAND.email}</a></p>
      </Section>

      <Section n="11" title="Updates to Policy">
        <p>We reserve the right to update this Privacy Policy at any time. Continued use of the Platform constitutes acceptance of revised policies.</p>
      </Section>

      <Section n="12" title="Contact Us">
        <p>For privacy concerns, contact:</p>
        <p><strong>Find Your MUA</strong><br />Email: <a href={`mailto:${BRAND.email}`} className="text-[#eb5381] underline">{BRAND.email}</a></p>
      </Section>
    </LegalLayout>
  );
}
